/**
 * GENERATED by apps/web/scripts/gen-pricing-snapshot.mts — do not edit.
 * Spec 147 §4.5 — the credit catalogue as pure data for the marketing
 * package; `check:pricing-snapshot` fails when it drifts from
 * packages/ops-db-schema/src/controlplane/seeds/plan-catalog.seed.ts. Regenerate: `pnpm --filter @repo/web gen:pricing-snapshot`.
 */
export const PRICING_SNAPSHOT = {
  "source": "packages/ops-db-schema/src/controlplane/seeds/plan-catalog.seed.ts",
  "starter_grant_credits": 100,
  "workspace_plans": [
    {
      "id": "free",
      "label": "Free",
      "is_free": true,
      "price_usd_cents_monthly": 0,
      "price_usd_cents_annual_per_month": 0,
      "credits_per_month": 0,
      "storage_credits_gib": 2
    },
    {
      "id": "starter",
      "label": "Team",
      "is_free": false,
      "price_usd_cents_monthly": 2000,
      "price_usd_cents_annual_per_month": 1600,
      "credits_per_month": 2300,
      "storage_credits_gib": 5
    },
    {
      "id": "pro",
      "label": "Business",
      "is_free": false,
      "price_usd_cents_monthly": 20000,
      "price_usd_cents_annual_per_month": 16000,
      "credits_per_month": 26000,
      "storage_credits_gib": 50
    },
    {
      "id": "ultra",
      "label": "Scale",
      "is_free": false,
      "price_usd_cents_monthly": 50000,
      "price_usd_cents_annual_per_month": 40000,
      "credits_per_month": 70000,
      "storage_credits_gib": 100
    }
  ],
  "member_plans": [
    {
      "id": "member-starter",
      "label": "Starter",
      "price_usd_cents_monthly": 2000,
      "price_usd_cents_annual_per_month": 1600,
      "credits_per_month": 2200
    },
    {
      "id": "member-pro",
      "label": "Pro",
      "price_usd_cents_monthly": 10000,
      "price_usd_cents_annual_per_month": 8000,
      "credits_per_month": 12000
    },
    {
      "id": "member-max",
      "label": "Max",
      "price_usd_cents_monthly": 20000,
      "price_usd_cents_annual_per_month": 16000,
      "credits_per_month": 25000
    }
  ],
  "packs": [
    {
      "id": "basic",
      "label": "Basic",
      "price_usd_cents": 1000,
      "credits": 1000,
      "bonus_pct": 0
    },
    {
      "id": "standard",
      "label": "Standard",
      "price_usd_cents": 2000,
      "credits": 2100,
      "bonus_pct": 5
    },
    {
      "id": "plus",
      "label": "Plus",
      "price_usd_cents": 10000,
      "credits": 11000,
      "bonus_pct": 10
    },
    {
      "id": "max",
      "label": "Max",
      "price_usd_cents": 50000,
      "credits": 60000,
      "bonus_pct": 20
    }
  ],
  "custom_topup": {
    "enabled": true,
    "min_usd_cents": 500,
    "max_usd_cents": 500000,
    "bonus_tiers": [
      {
        "min_usd_cents": 2000,
        "bonus_pct": 5
      },
      {
        "min_usd_cents": 10000,
        "bonus_pct": 10
      },
      {
        "min_usd_cents": 50000,
        "bonus_pct": 20
      }
    ]
  }
} as const;
